module.exports = __webpack_public_path__ + "img/wallet_02_advanced_1.e4747b6e.png";